<template>
  <div class="min-h-screen bg-gray-50 font-sans text-gray-900">
    <div v-if="esRutaDeApp" class="flex flex-col lg:flex-row h-screen overflow-hidden">

      <aside class="hidden lg:flex w-80 bg-sidebar-main border-r border-gray-100 flex-col shadow-sm">
        <div class="pt-8 text-center">
          <img src="@/assets/logo_red_2.png" class="mx-auto h-20 w-auto mb-2" alt="RED Logo">
          <!-- <span class="text-3xl font-black text-romance-red italic">Matchi</span> -->
        </div>

        <nav class="flex-1 px-4 space-y-2 mt-4">
          <router-link to="/app" class="nav-item group">
            <Flame class="icon-style" :size="24" />
            <span>Descubrir</span>
          </router-link>

          <router-link to="/messages" class="nav-item group">
            <MessageSquare class="icon-style" :size="24" />
            <span>Mensajes</span>
            <!-- <span class="ml-auto w-2 h-2 bg-romance-red rounded-full animate-pulse"></span> -->
          </router-link>

          <router-link to="/profile" class="nav-item group">
            <UserCircle class="icon-style" :size="24" />
            <span>Mi Perfil</span>
          </router-link>
        </nav>

       <!--  <div class="p-6 border-t border-gray-50">
          <button class="flex items-center gap-3 text-gray-400 hover:text-romance-red transition font-medium">
            <span>🚪</span> Cerrar sesión
          </button>
        </div> -->
      </aside>

      <main class="flex-1 relative bg-white lg:bg-gray-50 overflow-y-auto">
        <div class="mx-auto h-full w-full max-w-screen-2xl">
          <router-view />
        </div>
      </main>

      <nav class="lg:hidden h-15 bg-white/80 backdrop-blur-lg border-t border-gray-100 flex justify-around items-center z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.03)] fixed bottom-0 left-0 right-0">
        <router-link to="/app" class="nav-mobile-item group">
          <div class="icon-container">
            <Flame :size="28" stroke-width="2.5" class="icon-mobile" />
            <span class="dot-indicator"></span>
          </div>
        </router-link>

        <router-link to="/messages" class="nav-mobile-item group">
          <div class="icon-container">
            <MessageSquare :size="28" stroke-width="2.5" class="icon-mobile" />
            <span class="dot-indicator"></span>
          </div>
        </router-link>

        <router-link to="/profile" class="nav-mobile-item group">
          <div class="icon-container">
            <UserCircle :size="28" stroke-width="2.5" class="icon-mobile" />
            <span class="dot-indicator"></span>
          </div>
        </router-link>

      </nav>
    </div>

    <div v-else class="w-full min-h-screen">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { Flame, MessageSquare, UserCircle } from 'lucide-vue-next'
const route = useRoute()

const esRutaDeApp = computed(() => {
  const rutasPublicas = ['/', '/register', '/signin', '/terms', '/privacy', '/cookies', '/compliance', '/forgot-password', '/password']
  return !rutasPublicas.includes(route.path)
})

</script>